import { render, staticRenderFns } from "./tabulacao-list.vue?vue&type=template&id=ceb7f648"
import script from "./tabulacao-list.vue?vue&type=script&lang=js"
export * from "./tabulacao-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports